// extracted by mini-css-extract-plugin
export default {"form-field":"form-fields-generator_form-field__y1pfc","checkbox":"form-fields-generator_checkbox__a1nuC"};